import React from 'react';
import { createStore, applyMiddleware, compose, combineReducers, StoreEnhancer, Store, StoreEnhancerStoreCreator, ReducersMapObject } from 'redux';
import {routerReducer,routerMiddleware} from 'react-router-redux';
import logger from "redux-logger";
import thunk from "redux-thunk";
import promise from 'redux-promise';
import {reducers} from './reducers';
import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';

export const DevTools = createDevTools(
  <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-q">
    <LogMonitor theme="tomorrow" preserveScrollTop={false} />
  </DockMonitor>
);

export default function configureStore(history, initialState) {

  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  let middleware = null;

  if (typeof window !== "undefined") {
    middleware = composeEnhancers(applyMiddleware(thunk, promise, routerMiddleware(history)));
  } else {
    middleware = composeEnhancers(applyMiddleware(thunk, promise, routerMiddleware(history)));
  }

   const combReducer = combineReducers({
     ...reducers,
     routing: routerReducer
  })


  const store = createStore(
    combReducer,
    initialState,
    middleware
  );
  // Enable Webpack hot module replacement for reducers
  if (module.hot) {
      module.hot.accept('./reducers', () => {
          const nextRootReducer = require('./reducers');
          store.replaceReducer(nextRootReducer.reducers);
      });
  }
  return store;
}






//export default function configureStore(history, initialState) {

//  const windowIfDefined = typeof window === 'undefined' ? null : window;
//  const middleware = applyMiddleware(thunk,logger,promise);
//  //console.log(initialState);
//  console.log("Nesto za Log");
//  console.log(reducers);

//  return createStore(combineReducers(reducers),initialState,middleware);

//}
